var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddHoursPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_3497)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_3497",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_3497)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.5H12.5V13.5H15.5V12.5H12.5V9.49999H11.5V12.5H8.49999V13.5H11.5V16.5ZM12 21C10.8833 21 9.84165 20.7917 8.87499 20.375C7.90832 19.9583 7.06265 19.3877 6.33799 18.663C5.61265 17.9377 5.04165 17.0917 4.62499 16.125C4.20832 15.1583 3.99999 14.1167 3.99999 13C3.99999 11.8833 4.20832 10.8417 4.62499 9.87499C5.04165 8.90832 5.61265 8.06232 6.33799 7.33699C7.06265 6.61232 7.90832 6.04165 8.87499 5.62499C9.84165 5.20832 10.8833 4.99999 12 4.99999C13.1167 4.99999 14.1583 5.20832 15.125 5.62499C16.0917 6.04165 16.9377 6.61232 17.663 7.33699C18.3877 8.06232 18.9583 8.90832 19.375 9.87499C19.7917 10.8417 20 11.8833 20 13C20 14.1167 19.7917 15.1583 19.375 16.125C18.9583 17.0917 18.3877 17.9377 17.663 18.663C16.9377 19.3877 16.0917 19.9583 15.125 20.375C14.1583 20.7917 13.1167 21 12 21ZM5.89999 3.42499L6.62499 4.12499L3.12499 7.62499L2.42499 6.89999L5.89999 3.42499ZM18.1 3.42499L21.575 6.89999L20.875 7.62499L17.375 4.12499L18.1 3.42499ZM12 20C13.9333 20 15.5833 19.3167 16.95 17.95C18.3167 16.5833 19 14.9333 19 13C19 11.0667 18.3167 9.41665 16.95 8.04999C15.5833 6.68332 13.9333 5.99999 12 5.99999C10.0667 5.99999 8.41665 6.68332 7.04999 8.04999C5.68332 9.41665 4.99999 11.0667 4.99999 13C4.99999 14.9333 5.68332 16.5833 7.04999 17.95C8.41665 19.3167 10.0667 20 12 20Z",
    fill: "#6165ff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_3497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHoursPrimary);
export default __webpack_public_path__ + "static/media/add-hours-primary.d5043b7086d5c8d04dcbb609e9f37224.svg";
export { ForwardRef as ReactComponent };